<!-- <div class="dialog-wrapper">
  <div class="dialog-header">
    <h2 class="dialog-title">{{ data?.title }}</h2>

    <button class="close-btn" type="button" (click)="close()" aria-label="Close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="divider"></div>

  <h3 class="section-title">AMENITIES</h3>

  <mat-tab-group class="tabs" [dynamicHeight]="true">
    <mat-tab *ngFor="let t of tabs" [label]="t.label">
      <div class="tab-body">
        <div class="amenities-grid">
          <div class="amenity" *ngFor="let a of t.items">
            <span class="check">
               <img class="check" src="/assets/images/check-icon.svg" alt="check-icon" />
            </span>
            <span class="text">{{ a.name }}</span>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div> -->



<div class="dialog-wrapper">
  <div class="dialog-header">
    <h2 class="dialog-title">{{ data?.title }}</h2>

    <button class="close-btn" type="button" (click)="close()" aria-label="Close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="divider"></div>

  <h3 class="section-title">AMENITIES</h3>

  <mat-tab-group class="tabs" [dynamicHeight]="true">
    <mat-tab *ngFor="let t of tabs" [label]="t.label">
      <div class="tab-body">
        <div class="amenities-grid">
          <div class="amenity" *ngFor="let item of t.items">
            <span class="check">
              <img class="check" src="/assets/images/check-icon.svg" alt="check-icon" />
            </span>
            <span class="text">{{ item }}</span>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>